<template>
  <v-container fluid>
    <v-row>
      <v-col md="6">
        <OverallAverageCard />
      </v-col>
      <v-col md="6">
        <v-card
          v-for="(item,index) in [ higher_cycle_performance, lower_cycle_performance]"
          :key="index"
          :class="`bg-light text-center ${index == 0 ? 'mb-2' : ''}`"
          elevation="0"
        >
          <v-card-title
            v-if="higher_cycle_performance"
            class="border-bottom border-white text-center d-block font-weight-bold"
          >
            {{ item.id == higher_cycle_performance.id ? "Melhor ciclo" : "Pior ciclo" }}
          </v-card-title>
          <v-card-text class="d-flex justify-content-center align-items-center flex-column pt-3">
            <ProgressBar
              v-if="higher_cycle_performance"
              :completed="item.performance"
              :type="item.id == higher_cycle_performance.id ? 'success': 'danger'"
              :bars="10"
            />
            <p>
              <span class="font-weight-bold"> {{ item.cycle_name }} </span> - {{ item.performance.toFixed(0) }} %
            </p>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import OverallAverageCard from './OverallAverageCard.vue';
  import { mapGetters } from 'vuex'
  import ProgressBar from '@/common/components/ProgressBar.vue'

export default {
  components: {OverallAverageCard,  ProgressBar},
  computed:{
    ...mapGetters(['lower_cycle_performance','higher_cycle_performance']),
  }
}
</script>
